import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Skeleton from '@material-ui/lab/Skeleton'

interface Props {
  columns?: number
}

const ListSkeleton = ({ columns }: Props) => {
  if (!columns) {
    const theme = useTheme()
    const isSmallDevice = useMediaQuery(theme.breakpoints.down('xs'))
    const isMediumDevice = useMediaQuery(theme.breakpoints.down('sm'))

    if (isSmallDevice) {
      columns = 1
    } else if (isMediumDevice) {
      columns = 3
    } else {
      columns = 5
    }
  }

  const columnKeys = Array.from({ length: columns }, (_, i) => i + 1)

  return <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          {columnKeys.map((_, i) => (
            <TableCell key={i}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {columnKeys.map((_, i) => (
            <TableCell key={i} style={{ borderBottom: 'none' }}>
              <Skeleton />
              <Skeleton style={{ margin: '8px 0' }} />
              <Skeleton />
              <Skeleton style={{ margin: '8px 0' }} />
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
}

export default ListSkeleton
